export const CHRONIC_DISEASES = [
  'hypertension',
  'cardiovascularDisease',
  'heartFailure',
  'hyperlipidemia',
  'kidneyFailure',
  'chronicPain',
  'majorDepression',
  'anxiety',
  'sleepDisorder',
  'physicalDisability',
  'other',
];
